import { DisabledPrompt } from '@bcm-dev/bcms-vite';
import React, { useEffect, useRef, useState } from 'react';
import { SVGAsset } from 'res';
import "./styles.css";

/**
 * @function UIEditAccountNumberInput 
 * @param {STRING} className - Additional CSS class that we can pass to the UIEditAccountNumberInput component.
 * @param {STRING} value - Pass the default value to the UIEditAccountNumberInput component.
 * @param {STRING} placeHolder - Pass the placeHolder value to the UIEditAccountNumberInput component.
 * @param {React.Component} children - React components that's being wrapped by the UIEditAccountNumberInput component.
 * @returns {React.Component}
 * @example
 * <UIEditAccountNumberInput className="some-class" value="Some value" placeHolder="Some value">
 *  <UIButton className="primary-button">Button name</UIButton>
 * </UIEditAccountNumberInput>
 */
export default function UIEditAccountNumberInput(props) {
  const className = props.className ?? "";
  const dataPoint = props.dataPoint ? { "data-point" : props.dataPoint } : {};
  const type = props.type ?? "text";
  const maxLength = props.maxLength ?? 999;
  const inputField = useRef();
  const ignoreToggle = { ignoretoggle : props.ignoreToggle ? "true" : "false" };
  const isEditing = String(props.isEditing) === "true";
  const allowEditing = String(props.allowEditing) === "true";
  const [ state, setState ] = useState({ value: props.value ?? "", edit: isEditing });
  const label = props.label ?? "";
  let changeLabel = `Change ${ label.toLowerCase() }`;
  if(label === "") changeLabel = "";

  const onChange = evt => {
    setState({ ...state, value: inputField.current.value });

    if(props.onChange instanceof Function) {
      props.onChange(inputField.current.value, evt, inputField.current);
    }
  };

  const onEditClick = () => setState({ ...state, edit: true })

  useEffect(() => setState({ ...state, value: props.value ?? "" }), [ props.value ]);

  return(
    <div className={`form-row flex-height uitextinput edit ${className}`}>
      {/* Default state. */}
      { !state.edit &&
        <>
            <div className="text-input-label">{ label }</div>
            <div className="flex-container flex-horizontal">
                <div className="flex-width gray-text">{ state.value }</div>
                <DisabledPrompt>
                    <a onClick={ onEditClick }>
                        <span className="flex-container flex-horizontal show-link align-center">
                            <SVGAsset id="EyeIcon" className="eye-icon" />
                            <p>Show</p>
                        </span>
                    </a>
                </DisabledPrompt>
                { allowEditing && 
                <DisabledPrompt>
                    <a onClick={ onEditClick }>
                        <span className="flex-container flex-horizontal align-center edit-link">
                            <SVGAsset id="EditIcon" />
                            <p>Edit</p>
                        </span>
                    </a>
                </DisabledPrompt>
                }
            </div>
            <div className="gray-text disclaimer-text">
              { "For your protection, we only show part of your account number." }
            </div>
        </>
      }
      {/* Editing state. */}
      { state.edit && 
      <>
        <div className="text-input-label">{ changeLabel }</div>
        <div className="floating-label-input-container">
            
            <input className="floating-label-input form-row-input" maxLength={ maxLength } ref={ inputField }
            type={ type } placeholder=" " value={ state.value } onChange={ onChange } { ...dataPoint } { ...ignoreToggle }></input>
            <label className="floating-label form-row-label">{props.placeHolder}</label>
        </div>
        <span className="form-row-info-text gray-text">
            {props.children}
        </span>
      </>
      }
    </div>
  );
}